import React from 'react'
import Tooltip from '@material-ui/core/Tooltip'
import getTooltip from '../lib/tooltipMaker'

const BilecikWybor = ({ tytul, zlote, kodSprawozdania, nazwa }) => (
  <>
    <h1 className={'focusIndicator ' + kodSprawozdania}> </h1>
    <h1 className={'tloStruktury ' + kodSprawozdania}>
      <Tooltip title={getTooltip(kodSprawozdania)}>
        <div className={'logoStruktury ' + kodSprawozdania}>
          <h2>{nazwa}</h2>
        </div>
      </Tooltip>
    </h1>
    <div className="opisStruktury">
      <h4>{tytul}</h4>
      {zlote ? <h5>w złotych</h5> : <h5>w tysiącach</h5>}
    </div>
  </>
)

const Bilecik = ({ tytul, zlote, kodSprawozdania, nazwa }) => (
  <>
    <h4>{tytul}</h4>
    {zlote ? <h5>w złotych</h5> : <h5>w tysiącach</h5>}
    <Tooltip title={getTooltip(kodSprawozdania)}>
      <div className={kodSprawozdania}>
        <h2>{nazwa}</h2>
      </div>
    </Tooltip>
  </>
)

const getBilet = (zlote, tytul, nazwa, kod, wybor) => {
  if (wybor)
    return (
      <BilecikWybor
        zlote={zlote}
        tytul={tytul}
        nazwa={nazwa}
        kodSprawozdania={kod}
      />
    )
  return (
    <Bilecik zlote={zlote} tytul={tytul} nazwa={nazwa} kodSprawozdania={kod} />
  )
}

export default function NazwaStruktury({ KodSprawozdania, wybor }) {
  switch (KodSprawozdania) {
    case 'SprFinJednostkaInnaWZlotych':
      return getBilet(true, 'Jednostka INNA', 'IN', KodSprawozdania, wybor)
    case 'SprFinJednostkaMalaWZlotych':
      return getBilet(true, 'Jednostka MAŁA', 'MA', KodSprawozdania, wybor)
    case 'SprFinJednostkaMikroWZlotych':
      return getBilet(true, 'Jednostka MIKRO', 'MI', KodSprawozdania, wybor)
    case 'SprFinOpWZlotych':
      return getBilet(
        true,
        wybor ? 'Organizacja pozarządowa' : 'Org. pozarządowa',
        'OP',
        KodSprawozdania,
        wybor,
      )
    case 'SprFinJednostkaInnaWTysiacach':
      return getBilet(false, 'Jednostka INNA', 'IN', KodSprawozdania, wybor)
    case 'SprFinJednostkaMalaWTysiacach':
      return getBilet(false, 'Jednostka MAŁA', 'MA', KodSprawozdania, wybor)
    case 'SprFinJednostkaMikroWTysiacach':
      return getBilet(false, 'Jednostka MIKRO', 'MI', KodSprawozdania, wybor)
    case 'SprFinOpWTysiacach':
      return getBilet(
        false,
        wybor ? 'Organizacja pozarządowa' : 'Org. pozarządowa',
        'OP',
        KodSprawozdania,
        wybor,
      )
    case 'SprFinSkonsolidowanaJednostkaInnaWZlotych':
      return getBilet(
        true,
        wybor ? 'Skonsolidowana jednostka INNA' : 'Skonsolid. jedn. INNA',
        'SIN',
        KodSprawozdania,
        wybor,
      )
    case 'SprFinSkonsolidowanaJednostkaInnaWTysiacach':
      return getBilet(
        false,
        wybor ? 'Skonsolidowana jednostka INNA' : 'Skonsolid. jedn. INNA',
        'SIN',
        KodSprawozdania,
        wybor,
      )
    case 'SprFinDomMaklerskiWZlotych':
      return getBilet(
        true,
        wybor ? 'Dom maklerski' : 'Dom maklerski',
        'DM',
        KodSprawozdania,
        wybor,
      )
    case 'SprFinDomMaklerskiWTysiacach':
      return getBilet(
        false,
        wybor ? 'Dom maklerski' : 'Dom maklerski',
        'DM',
        KodSprawozdania,
        wybor,
      )
    default:
      return null
  }
}
